import { Box, FormLabel } from '@mui/material';
import React from 'react';

export default function EditPanelLabel({ children }: { children: React.ReactNode }) {
    return (
        <FormLabel sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>{children}</Box>
        </FormLabel>
    );
}
